export default __webpack_public_path__ + "static/media/woman-1.89ebfb50.jpg";